export default __webpack_public_path__ + "static/media/bg.03d4787e.webp";